import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import axios from 'axios';

function NoticesDisplay() {
  const [notices, setNotices] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editTitle, setEditTitle] = useState("");

  // Fetch notices
  const loadNotices = async () => {
    const res = await fetch("https://spst.in/myapp/api/fetch_notices.php");
    const data = await res.json();
    setNotices(data);
  };

  useEffect(() => {
    loadNotices();
  }, []);

  // Delete notice
  const deleteNotice = async (id) => {
    await fetch("https://spst.in/myapp/api/delete_notice.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    loadNotices();
  };

  // Save updated data
  const updateNotice = async () => {
    await fetch("https://spst.in/myapp/api/update_notice.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: editId, title: editTitle }),
    });

    setEditId(null);
    setEditTitle("");
    loadNotices();
  };

  return (
    <div>
      {/* <h4 style={{fontWeight:'700'}}>Updates</h4> */}

      <table className="table">
        <thead>
          <tr>
            {/* <th style={{color:'black'}}>ID</th> */}
            <th style={{color:'black',width:'70%'}}>Update</th>
            <th style={{color:'black',width:'30%'}}></th>
          </tr>
        </thead>

        <tbody>
          {notices.map((n) => (
            <tr key={n.id}>
              {/* <td style={{color:'black'}}>{n.id}</td> */}

              <td style={{color:'black'}}>
                {editId === n.id ? (
                  <textarea className="form-control" style={{width:'100%',height:'50vh'}}
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                  ></textarea>
                ) : (
                  n.title
                )}
              </td>

              <td>
                {editId === n.id ? (
                  <>
                    <button className="btn btn-success" onClick={updateNotice}>Save</button>
                    <button className="btn btn-secondary" onClick={() => setEditId(null)}>Cancel</button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        setEditId(n.id);
                        setEditTitle(n.title);
                      }}
                    className="btn btn-secondary">
                      Edit
                    </button>

                    <button className="btn btn-danger" onClick={() => deleteNotice(n.id)}>
                      Delete
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default NoticesDisplay;
